<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <div v-if="!routeList.includes(`${$route.name}`)">
      <cartoon-kid :key="'F'"></cartoon-kid>
    </div>
    <modal
      ref="messagePop"
      :closeFnValue="false"
      :showClsoeBtn="true"
      :sureText="sureTextDe"
      :cancelText="cancelTextDe"
      :btnType="btnCategory"
      @submit="sure"
      @cancel="cancel"
    >
      <template v-slot:top>
        <p v-html="curMsgInfo.title || ''"></p>
      </template>
      <template v-slot:body>
        <p v-html="curMsgInfo.content || ''"></p>
      </template>
    </modal>
  </div>
</template>
<script>
import "@/assets/scss/common.scss";
import CartoonKid from "./views/cartoon-kid/index.vue";
import Modal from "./components/common/modal.vue";
import {
  _getMessageReceive,
  _messageReaded,
  _projectSetting,
} from "./api/message";
import { Toast } from "vant";
import { decryptBy } from "@/assets/js/encryption";
import Cookies from "js-cookie";
import { landType } from "@/common/utils/utils";
//templateId 21是随访 49是报告 19问卷 11筛查
const TempId = {
  Q: 21, // 随访提醒
  R: 49, //报告提醒
  U: 19, // 问卷提醒
  S: 11, // 筛查提醒
};
export default {
  components: {
    CartoonKid,
    Modal,
  },
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      totalPage: 0, //总页数
      btnCategory: "1",
      userInfoObj: {},
      routeList: [
        "login", //登录页
        "identity", // 身份选择页
        "information", //注册个人资料页
        "loading-page", //loading跳转页
        "course", //积极养育课
        "test-center", //测试中心
        "grow-group", //成长社团
      ],
      isRouterAlive: true,
      shareTitle: "",
      sureTextDe: "",
      cancelTextDe: "",
      receiveParams: {
        asc: false,
        currentPage: 1,
        orderByField: "createTime",
        pageSize: 9999,
        itemUrl: "",
        queryData: {
          createTimeEnd: "", //发送时间(止)
          createTimeStart: "", //发送时间(起)
          readed: 0, //消息是否已读 0-未读，1-已读
          receiveId: "", //接收者ID
          receiveSys: 2, //1-B端，2-C端
          sendType: 1, //1-站内，2-短信
          title: "", //消息标题
        },
      },
      msgDialogInfoDatas: {
        ls: [],
        curIndex: 0,
        QLs: [],
        RLs: [],
        ULs: [],
        SLs: [],
      },
      T: "", //定时器轮询消息查询
    };
  },
  computed: {
    curMsgInfo() {
      let curMsgInfo =
        this.msgDialogInfoDatas.ls[this.msgDialogInfoDatas.curIndex];
      return curMsgInfo ?? {};
    },
    itemId() {
      return this.msgDialogInfoDatas.ls[this.msgDialogInfoDatas.curIndex].id;
    },
    itemUrl() {
      let token = Cookies.get("token");
      return this.curMsgInfo?.url + "&" + token;
    },
  },
  watch: {
    "msgDialogInfoDatas.curIndex": {
      handler() {
        this.updateMsgBtnStatus();
      },
      immediate: true,
    },
    curMsgInfo() {
      let curMsgInfo = this.curMsgInfo;
      //问卷
      if (curMsgInfo.templateId == TempId.U) {
        this.btnCategory = "2";
        this.cancelTextDe = "下一条";
        this.sureTextDe = "去填写";
      }
      //报告
      if (curMsgInfo.templateId == TempId.R) {
        this.btnCategory = "3";
        this.cancelTextDe = "下一条";
      }
      // 随访
      if (curMsgInfo.templateId == TempId.Q) {
        this.btnCategory = "1";
        this.sureTextDe = "去填写";
      }
      // 筛查
      if (curMsgInfo.templateId == TempId.S) {
        this.btnCategory = "2";
        this.cancelTextDe = "下一条";
        this.sureTextDe = "去填写";
      }
    },
    $route(to, from) {
      // 进入到量表填写页面，也不再弹出提示
      if (
        to.path != "/login" &&
        to.path != "/test" &&
        to.path != "/growClub" &&
        to.path != "/template"
      ) {
        // this.getMessageReceive(this.receiveParams);
        // this.T = setInterval(() => {
        //   this.getMessageReceive(this.receiveParams);
        // }, 600000);
      }
      if (to.path == "/login") {
        clearInterval(this.T);
      }
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    updateMsgBtnStatus() {
      if (
        this.msgDialogInfoDatas.curIndex ==
        this.msgDialogInfoDatas.ls.length - 1
      ) {
        this.$nextTick(() => {
          this.btnCategory = "1";
          this.sureTextDe = "去查看";
        });
      }
    },
    cancel(val) {
      if (val == 1) {
        // 点击的canceBtn
        // 标记已读
        let params = [this.itemId];
        // await this.messageReaded(params);
        this.messageReaded(params);
        // 寻找下一条,应该重置当前页为1
        this.receiveParams.currentPage = 1;
        // this.getMessageReceive(this.receiveParams);
        if (
          this.msgDialogInfoDatas.curIndex <
          this.msgDialogInfoDatas.ls.length - 1
        ) {
          this.msgDialogInfoDatas.curIndex++;
        }
      }
      if (val == 2) {
        // 点击左上角关闭按钮
        clearInterval(this.T);
        // 关闭弹框
        this.$bus.$emit("closeModal", false);
        this.$refs.messagePop.closeDialog();
      }
      //目前只有报告可以一直加

      // // 当前页大于总页 不再发请求获取数据
      // if (this.receiveParams.currentPage == this.totalPage) {
      //   // 当反复点击请求数据下一条的时候，如果到了最后一页，只显示一个去填写的按钮
      //   this.btnCategory = "1";
      //   this.sureTextDe = "去填写";
      //   return;
      // }
    },
    sure() {
      // 点击去填写，表示也已读，需要标识
      let params = [this.itemId];
      this.messageReaded(params);
      // 跳转到去填写页面
      if (this.curMsgInfo.title && this.itemId && this.itemUrl) {
        if (this.curMsgInfo.title == "报告生成提醒") {
          this.$router.push({
            path: "/growClub?type=1",
          });
        } else if (this.itemId && this.itemUrl) {
          this.$router.push({
            path: "/test",
            query: {
              title: this.shareTitle,
              projectUrl: this.itemUrl,
              resultId: this.itemId,
            },
          });
        }
        // 关闭弹框
        this.$bus.$emit("closeModal", false);
        this.$refs.messagePop.closeDialog();
      } else {
        Toast("跳转异常，请稍候尝试一下哦！");
      }
    },
    // 接收消息接口
    async getMessageReceive(receiveParams) {
      return _getMessageReceive(receiveParams).then((res) => {
        let { code, message, data } = res;
        if (res && code === 200) {
          let ls = data?.records ?? [];
          //优先处理问卷
          let QLs = ls.filter((item) => item.templateId == TempId.U);
          let RLs = ls.filter((item) => item.templateId == TempId.R);
          let ULs = ls.filter((item) => item.templateId == TempId.Q);
          let SLs = ls.filter((item) => item.templateId == TempId.S);
          //问卷数组
          this.msgDialogInfoDatas.QLs = QLs;
          //报告数组
          this.msgDialogInfoDatas.RLs = RLs;
          //问卷提醒
          this.msgDialogInfoDatas.ULs = ULs;
          // 筛查提醒
          this.msgDialogInfoDatas.SLs = SLs;
          //总数据,问卷优先
          this.msgDialogInfoDatas.ls = QLs.concat(RLs).concat(ULs).concat(SLs);
          this.msgDialogInfoDatas.curIndex = 0;
          this.projectSetting();
          //有数据就弹出
          if (ls.length > 0) {
            this.$refs.messagePop.openDialog();
          } else {
            this.$refs.messagePop.closeDialog();
          }
          this.updateMsgBtnStatus();
          return ls;
          // const hasToken = Cookies.get("token");
          // this.itemId = data.records?.[0]?.id ?? "";
          // this.itemUrl =
          //   data.records.length > 0 ? data.records[0].url + "&" + hasToken : "";
          // this.curMsgIndex = 0;
          // this.msgInfoDatas = data?.records ?? [];
          // if (this.msgInfoDatas.length > 1) {
          //   this.$refs.messagePop.openDialog();
          // }
          // // 当信息只有一条的时候
          // this.$refs.messagePop.openDialog();
          // this.btnCategory = "1";
          // if (data.total === 1) {
          //   this.$refs.messagePop.openDialog();
          //   // this.$bus.$emit('closeModal',true)
          //   this.btnCategory = "1";
          //   if (this.title == "报告生成提醒") {
          //     this.sureTextDe = "去查看";
          //   } else {
          //     this.sureTextDe = "去填写";
          //   }
          // } else if (data.total > 1) {
          //   this.$refs.messagePop.openDialog();
          //   // this.$bus.$emit('closeModal',true)
          //   this.btnCategory = "2";
          //   this.cancelTextDe = "下一条";
          //   if (this.title == "报告生成提醒") {
          //     this.sureTextDe = "去查看";
          //   } else {
          //     this.sureTextDe = "去填写";
          //   }
          // } else if (data.total === 0) {
          //   this.$refs.messagePop.closeDialog();
          //   // this.$bus.$emit('closeModal',false)
          // }
          // this.totalPage = data.total;
          // // 当前页大于总页 不再发请求获取数据
          // if (this.receiveParams.currentPage == this.totalPage) {
          //   // 当反复点击请求数据下一条的时候，如果到了最后一页，只显示一个去填写的按钮
          //   this.btnCategory = "1";
          //   if (this.title == "报告生成提醒") {
          //     this.sureTextDe = "去查看";
          //   } else {
          //     this.sureTextDe = "去填写";
          //   }
          //   return;
          // }
        } else {
          Toast(message);
        }
      });

      // let res = await _getMessageReceive(receiveParams).catch((err) => {
      //   return {};
      // });
      // let { code, message, data } = res;
      // if (res && code === 200) {
      //   const hasToken = Cookies.get("token");
      //   this.itemId = "";
      //   this.itemId = data.records.length > 0 ? data.records[0].id : "";
      //   this.itemUrl = "";
      //   this.itemUrl =
      //     data.records.length > 0 ? data.records[0].url + "&" + hasToken : "";
      //   this.curMsgIndex = 0;
      //   this.msgInfoDatas = data?.records ?? [];
      //   if (this.msgInfoDatas.length > 1){
      //     this.$refs.messagePop.openDialog();
      //   }
      //   // // 当信息只有一条的时候
      //   // this.$refs.messagePop.openDialog();
      //   // this.btnCategory = "1";
      //   // if (data.total === 1) {
      //   //   this.$refs.messagePop.openDialog();
      //   //   // this.$bus.$emit('closeModal',true)
      //   //   this.btnCategory = "1";
      //   //   if (this.title == "报告生成提醒") {
      //   //     this.sureTextDe = "去查看";
      //   //   } else {
      //   //     this.sureTextDe = "去填写";
      //   //   }
      //   // } else if (data.total > 1) {
      //   //   this.$refs.messagePop.openDialog();
      //   //   // this.$bus.$emit('closeModal',true)
      //   //   this.btnCategory = "2";
      //   //   this.cancelTextDe = "下一条";
      //   //   if (this.title == "报告生成提醒") {
      //   //     this.sureTextDe = "去查看";
      //   //   } else {
      //   //     this.sureTextDe = "去填写";
      //   //   }
      //   // } else if (data.total === 0) {
      //   //   this.$refs.messagePop.closeDialog();
      //   //   // this.$bus.$emit('closeModal',false)
      //   // }
      //   // this.totalPage = data.total;
      //   // // 当前页大于总页 不再发请求获取数据
      //   // if (this.receiveParams.currentPage == this.totalPage) {
      //   //   // 当反复点击请求数据下一条的时候，如果到了最后一页，只显示一个去填写的按钮
      //   //   this.btnCategory = "1";
      //   //   if (this.title == "报告生成提醒") {
      //   //     this.sureTextDe = "去查看";
      //   //   } else {
      //   //     this.sureTextDe = "去填写";
      //   //   }
      //   //   return;
      //   // }
      // } else {
      //   Toast(message);
      // }
    },
    //
    projectSetting() {
      let projectKey;
      projectKey = this.getQuery("id");
      if (projectKey) {
        _projectSetting(projectKey).then((res) => {
          if (res.code == 200) {
            this.shareTitle = res.data.publishTitle;
          } else {
            this.$toast(res.message);
          }
        });
      }
    },
    //获取url中的参数
    getQuery(name) {
      let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      let r = this.itemUrl;
      if (reg.test(r)) return unescape(RegExp.$2.replace(/\+/g));
    },
    // 消息已读
    async messageReaded(readParams) {
      try {
        let res = await _messageReaded(readParams);
        let { code, message, data } = res;
        if (!res && code !== 200) {
          Toast(message);
        }
      } catch (error) {}
    },
  },
  created() {
    // userInfo
    if (localStorage.getItem("parentsInfor")) {
      let info = localStorage.getItem("parentsInfor");
      let user = JSON.parse(decryptBy(info));
      this.userInfoObj = user;
    }

    //记录一下是否是通过登陆进入的系统
    //landByLogin  1是通过登陆进的系统 2不是通过登陆进的系统(缓存) 3未登录
    landType.noLand();
    if (Cookies.get("token")) {
      landType.landByToken();
    }
  },
  mounted() {
    if (this.userInfoObj != null) {
      this.receiveParams.queryData.receiveId = this.userInfoObj.id;
    }

    // 10分钟刷新一次读取信息
    // if (Cookies.get('token')) {
    // 	this.getMessageReceive(this.receiveParams)
    // 	this.T = setInterval(() => {
    // 		this.getMessageReceive(this.receiveParams)
    // 	},1  * 1000 * 10)
    // }
  },
  beforeDestroy() {
    clearInterval(this.T);
  },
};
</script>
<style lang="scss">
/* 滚动条样式 */
::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  box-shadow: inset 0 0 5px rgba(182, 176, 176, 0.2);
  background: #eef4fa; //滚动条颜色
}
::-webkit-scrollbar-track {
  box-shadow: none;
  border-radius: 4px;
  background: transparent; //底色
}
#app {
  width: 100%;
  height: 100%;
  overflow: scroll;

  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }

  --font-size-color: #00aadf;
  --btn-backgruond-color: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
  --font-bold-size: 500;
}

// 全局组件toast样式重置
.mint-toast {
  z-index: 2999 !important;
}

body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-text-size-adjust: 100% !important ;
  text-size-adjust: 100% !important;
}

.mint-toast.is-placemiddle.rotation {
  // position: absolute;
  transform: rotate(90deg) translateZ(3px);
  transform-origin: 25% -25%;
  z-index: 9999999 !important;
}

.van-dialog.rotation {
  transform: rotate(90deg);
  transform-origin: 30% -16%;
  // translate3d(-50%,-50%,0)
}

.index-container {
  min-height: 100vh;
  background: url("assets/images/index/header-bg.png") no-repeat;
  background-size: 100%;
  background-position-y: -84px;
  padding-top: 8px;
  background-color: #f5f7fa;
}
.van-nav-bar {
  .van-nav-bar__title {
    font-size: 18px;
    color: #161515;
    font-weight: 500;
  }
  .van-nav-bar__arrow {
    font-size: 22px;
  }
}
</style>
